let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("cvRSN")).then(() => parcelRequire('gqA4D'));